<template>
  <template v-if="context === 'header'">
    <nav class="ca-simplified-nav-bar ca-simplified-nav-bar--in-header">
      <template v-if="parentItem">
        <span class="ca-simplified-nav-bar__parent-title caption-medium">
          {{ parentItem.title }}
        </span>
        <div class="ca-simplified-nav-bar__divider" aria-hidden="true" />
      </template>
      <div class="ca-simplified-nav-bar__scroll">
        <button
          v-for="(item, colIdx) in items"
          class="ca-simplified-nav-bar__btn rounded-xs caption-medium"
          :class="{ 'is-active': currentPath.startsWith(item.url) }"
          :key="`simplified-nav-header-${colIdx}`"
          :disabled="isLoading"
          @click.prevent="!isLoading && emit('navigate-category', item)"
        >
          <span>{{ item.title }}</span>
        </button>
      </div>
    </nav>
  </template>

  <template v-else-if="context === 'outside'">
    <nav class="ca-simplified-nav-bar ca-simplified-nav-bar--outside">
      <template v-if="parentItem">
        <span class="ca-simplified-nav-bar__parent-title caption-medium">
          {{ parentItem.title }}
        </span>
        <div class="ca-simplified-nav-bar__divider" aria-hidden="true" />
      </template>
      <div class="ca-simplified-nav-bar__scroll">
        <button
          v-for="(item, colIdx) in items"
          class="ca-simplified-nav-bar__btn rounded-xs caption-medium"
          :class="{ 'is-active': currentPath.startsWith(item.url) }"
          :key="`simplified-nav-outside-${colIdx}`"
          :disabled="isLoading"
          @click.prevent="!isLoading && emit('navigate-category', item)"
        >
          <span>{{ item.title }}</span>
        </button>
      </div>
    </nav>
    <hr class="ca-header__megamenu-separator" />
  </template>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  parentItem: {
    type: Object,
    default: null,
  },
  currentPath: {
    type: String,
    default: "",
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  context: {
    type: String,
    default: "header",
    validator: (v) => ["header", "outside"].includes(v),
  },
});

const emit = defineEmits(["navigate-category"]);
</script>

<style scoped lang="scss">
.ca-simplified-nav-bar__btn {
  flex-shrink: 0;
  min-height: var(--size-8);
  padding: 12px var(--size-5);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--size-3);
  background: white;
  border: none;
  cursor: pointer;
  color: var(--ca-color-theme-primary);
  -webkit-tap-highlight-color: transparent;
  letter-spacing: var(--letter-spacing-sm);
  white-space: nowrap;
  flex: 1 0 0;

  &:hover {
    background: var(--ca-color-hover-pressed-container-high-hover);
  }
  &:focus-visible {
    outline: 1px solid var(--ca-color-feedback-info);
  }
  &:active {
    background: var(--ca-color-hover-pressed-inverted-hover-light);
  }
  &.is-active {
    background: var(--ca-color-hover-pressed-container-high-hover);
  }
  &:disabled {
    cursor: not-allowed;
  }
}

.ca-simplified-nav-bar__parent-title {
  display: flex;
  align-items: center;
  white-space: nowrap;
  flex-shrink: 0;
  color: var(--ca-color-theme-primary);
  font-weight: var(--font-weight-semibold);

  @media (min-width: 768px) and (max-width: 1024px) {
    font-weight: var(--font-weight-medium);
  }
}

.ca-simplified-nav-bar__divider {
  width: 1px;
  align-self: stretch;
  background-color: var(--ca-color-text-light);
  flex-shrink: 0;
  margin: var(--size-2) 0;
}

.ca-simplified-nav-bar__scroll {
  display: flex;
  gap: var(--size-3);
  overflow-x: auto;
  scrollbar-width: none;
  flex: 1;
  min-width: 0;
  justify-content: space-around;

  &::-webkit-scrollbar {
    display: none;
  }
}

.ca-simplified-nav-bar--in-header {
  display: none;

  @media (max-width: 1024px) {
    display: flex;
    align-items: center;
    overflow: hidden;
    gap: var(--size-3);
  }

  @media (max-width: 767px) {
    display: none;
  }
}

.ca-simplified-nav-bar--outside {
  display: flex;
  align-items: center;
  gap: var(--size-3);
  flex-wrap: nowrap;
  margin-top: var(--size-3);
  background: transparent;
  overflow: hidden;

  @media (min-width: 768px) {
    display: none;
  }
}

.ca-header__megamenu-separator {
  border: none;
  border-top: 1px solid var(--ca-color-text-light);
  margin: var(--size-5) 0;

  @media (min-width: 768px) {
    display: none;
  }
}
</style>
